<script>
    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';
    import MainConainer from '@/components/container/MainContainer.vue';

    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

    import ChangelogList from '@/components/page-change-log/ChangelogList.vue';

    export default {
        components: {
            LeftPanel: LeftPanel,
            RightContainer: RightContainer,
            MainConainer: MainConainer,

            ButtonReturn: ButtonReturn,

            ChangelogList: ChangelogList,
        }
    }
</script>


<template>
    <MainConainer>
        <LeftPanel>
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <ChangelogList />
        </RightContainer>
    </MainConainer>
</template>